import CS from "../../services/commonService";

const RenderUser = ({ profileImageUrl, firstName, lastName }) => {
	return (
		<div className="d-flex align-items-center pr-3">
			<div className="flex-auto">{CS.renderImageUrl(profileImageUrl)}</div>
			<div className="d-flex flex-column flex-wrap">
				<span className="pl-2">
					{firstName} {lastName}
				</span>
			</div>
		</div>
	);
};

export default RenderUser;
